import { useCallback } from 'react';
import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import { useConfig } from '../store/configStore.js';

const dicts = { fr, en, de, es, it, pt };

export const SUPPORTED = [
  { code: 'fr', label: 'Français', flagCode: 'fr' },
  { code: 'en', label: 'English', flagCode: 'gb' },
  { code: 'de', label: 'Deutsch', flagCode: 'de' },
  { code: 'es', label: 'Español', flagCode: 'es' },
  { code: 'it', label: 'Italiano', flagCode: 'it' },
  { code: 'pt', label: 'Português', flagCode: 'pt' },
];

const FALLBACK = 'fr';

function lookup(dict, key) {
  const parts = key.split('.');
  let cur = dict;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

function interpolate(str, vars) {
  if (!vars) return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (k in vars ? String(vars[k]) : `{${k}}`));
}

export function translate(lang, key, vars) {
  const dict = dicts[lang] || dicts[FALLBACK];
  let val = lookup(dict, key);
  if (val == null) val = lookup(dicts[FALLBACK], key);
  if (val == null) return key;
  return interpolate(val, vars);
}

export function useT() {
  const lang = useConfig((s) => s.config.settings.language);
  return useCallback((key, vars) => translate(lang, key, vars), [lang]);
}

export function useLang() {
  return useConfig((s) => s.config.settings.language);
}
